import { render } from "./BalBtnGroup.vue?vue&type=template&id=2d515978&scoped=true&ts=true"
import script from "./BalBtnGroup.vue?vue&type=script&lang=ts"
export * from "./BalBtnGroup.vue?vue&type=script&lang=ts"

import "./BalBtnGroup.vue?vue&type=style&index=0&id=2d515978&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d515978"]])

export default __exports__